// extracted by mini-css-extract-plugin
export default {"page_container":"NotFound_page_container__1TNDN","header":"NotFound_header__YkA-r","link":"NotFound_link__1tfBG"};